/**
 * -- MAIN.JS --
 * This file is the main entry point for Vite.
 * It imports styles and scripts automatically via glob patterns.
 * This theme also includes AlpineJS and HTMX.
 */

import 'vite/modulepreload-polyfill';
import './styles/styles.js';
import './js/scripts.js'; // This will automatically import all component JS files
import './js/event-filter.js'; // Event filtering functionality
import './js/page-header.js'; // Page header parallax
import './js/scroll-animations.js'; // Scroll-triggered animations
import './js/blog-grid.js'; // Blog grid AJAX pagination (was WPCode snippet #1317)
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import htmx from 'htmx.org';

// Alpine JS
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// HTMX
window.htmx = htmx;

// Testing
document.addEventListener('DOMContentLoaded', () => { 
  console.log('Vite files loaded');
});

